"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddOrUpdateFactoryFromJS = exports.AddOrUpdateFactory = void 0;
const __1 = require("../");
const immutable_1 = require("immutable");
exports.AddOrUpdateFactory = (0, immutable_1.Record)({
    items: (0, immutable_1.List)(),
    windowId: ''
});
const AddOrUpdateFactoryFromJS = function (data) {
    var _a;
    const items = ((_a = data.items) === null || _a === void 0 ? void 0 : _a.map(value => (0, __1.ToolbarItemFactoryFromJS)(value))) || [];
    return (0, exports.AddOrUpdateFactory)({
        items: (0, immutable_1.List)(items),
        windowId: data.windowId
    });
};
exports.AddOrUpdateFactoryFromJS = AddOrUpdateFactoryFromJS;
//# sourceMappingURL=IAddOrUpdate.js.map